import { useEffect, useMemo, useRef, useState } from 'react';
import taxService from '@/services/billing/taxService';
import expenseService from '@/services/billing/expenses/expenseService';
import matterService from '@/services/matter/matterService';
import userService from '@/services/setting/userService';
import { useAbility } from '@/providers/';
import { toast } from 'sonner';
import { KeenIcon, DefaultTooltip } from '@/components';
import { Can } from '@casl/react';
import { ItemsModal } from '@/pages/billing';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import 'datatables.net-select-dt';
import 'datatables.net-responsive-dt';
import { createRoot } from 'react-dom/client';
import { useAuthContext } from '@/auth';
import { Link, useNavigate } from 'react-router-dom';
import { renderMultiAvatars, FiltersToFormData, getAccessToken, decodeHtmlEntities } from '@/utils'
import { createDataTableOptions, createDataTableConfig } from '@/utils';
import { ConfirmationModal } from '@/components/modal';
import { useConfirmationModal, useContactLookup } from '@/hooks';
import { SelectInput, DateInput, STATUS_INVOICE_OPTIONS, FilterContainer } from '@/components/TableFilter'
import { cn } from '@/lib/utils';
import { goTo403 } from "@/utils/Navigation";
import { useUserOptions } from '@/hooks'

DataTable.use(DT);
const ExpensesContactTab = ({ contactID }) => {
  const { logout } = useAuthContext();
  const fetchContactLookup = useContactLookup();
  const [isLoading, setIsLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('create');
  const [selectedData, setSelectedData] = useState(null);
  const [dataLoading, setDataLoading] = useState(false)
  const [contactTypeData, setContactTypeData] = useState([])
  const [taxesData, setTaxesData] = useState([])
  const [itemId, setItemId] = useState(null)
  const { ability } = useAbility();
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState({
    billed_by: null,
    status: null,
    contact_id: contactID,
    matter: null,
    from_date: null,
    to_date: null,
    date_range: null,
  });
  const API_URL = import.meta.env.VITE_APP_BASE_URL;
  const token = getAccessToken();
  const tableRef = useRef(null);
  const filterRef = useRef(filterData);
  const formikRef = useRef();
  const canDeleteExpense = ability.can('delete', 'expense');
  const canEditExpense = ability.can('handle', 'expense');
  const Navigate = useNavigate()
  const { isOpen, actionId, openModal, closeModal } = useConfirmationModal();
  const loadUserOptions = useUserOptions({ defaultPageSize: 20 });


  useEffect(() => {
    filterRef.current = filterData;
  }, [filterData]);

  const badgeClasses = {
    billable: 'badge-success',
    billed: 'badge-info',
    paid: 'badge-primary',
    not_billable: 'badge-danger',
  }

  const columns = [
    // {
    //   title: 'S#',
    //   name: 'serial',
    //   data: null,
    //orderable: true,se,
    //   render: (data, type, row, meta) => meta.row + 1,
    // },
    {
      data: 'category',
      title: 'Category',
      name: 'category',
      orderable: true,
      render: function (data, type, row) {
        const badgeClass = row.category.active ? 'badge-success' : 'badge-danger';
        const label = row.category.active ? 'Active' : 'Inactive';
        return `<div>
          <div class="text-xs my-1">Name: ${row.category.category_name}</div>
          <div class="text-xs my-1">Code: ${row.category.category_code}</div>
          <span class="badge badge-xs badge-outline ${badgeClass} gap-1 items-center">${label}</span>
        </div>`;
      }
    },
    {
      data: 'status',
      title: 'Status',
      name: 'status',
      render: function (value) {
        return `<span class="badge badge-pill badge-outline capitalize ${badgeClasses[value]}">${value}</span>`
      }
    },
    { data: 'date', title: 'Date', name: 'date' },
    {
      data: 'rate',
      title: 'Rate',
      name: 'rate',
      render: function (data, type, row) {
        return `<div >$${row.rate}</div>`;
      }
    },
    {
      data: 'total',
      title: 'Total',
      name: 'total',
      render: function (data, type, row) {
        return `<div>$${row.total}</div>`;
      }
    },
    { data: 'quantity', title: 'Quantity' },
    {
      data: 'contact',
      title: 'Contact',
      name: 'contact',
      orderable: true,
      render: function (data, type, row) {
        return `<div id="contact-cell-${row.id}"></div>`;
      }
    },
    {
      data: 'matter',
      title: 'Matter',
      orderable: true,
      render: function (data, type, row) {
        return `<div id="matter-cell-${row.id}"></div>`;
      }
    },
    {
      title: 'Billed By',
      // name: 'assigned_to',
      data: null,
      orderable: true,
      searchable: false,
      render: function (data, type, row) {
        return `<div id="billed-by-${row.id}"></div>`;
      }
    },
    {
      title: 'Created At',
      name: 'created_at',
      data: 'created_at',
    },
    {
      title: '',
      data: null,
      orderable: true,
      searchable: false,
      render: function (data, type, row) {
        return `<div id="test-cell-${row.id}"></div>`;
      }
    }
  ];

  const handleSubmit = async (formData) => {
    const isEdit = mode === 'edit';
    const action = isEdit ? expenseService.updateExpense : expenseService.createExpense;
    const args = isEdit ? [formData, itemId] : [formData];
    try {
      isEdit ? setLoading(true) : setIsLoading(true);
      const { data, status } = await action(...args);
      if (status) {
        setOpen(false);
        refresh();
        toast.success(`Expense ${isEdit ? 'Updated' : 'Created'} Successfully`, {
          description: `Expense ${isEdit ? 'updated' : 'created'} successfully.`,

        })
      }
    } catch (error) {
      console.error('Error', error)
      if (error.message == '422 Unprocessable Entity. Validation failed.') {
        const validationErrors = error.errors
        const formattedErrors = Object.fromEntries(
          Object.entries(validationErrors).map(([key, value]) => [key, value[0]])
        );

        formikRef.current?.setErrors(formattedErrors);
        toast.error('Validation Error.', {
          description: 'Please check your input. Some fields may be invalid.',

        });
      }
    } finally {
      isEdit ? setLoading(false) : setIsLoading(false);
    }
  };

  const handleDelete = async () => {
    closeModal();
    try {
      const { status } = await expenseService.deleteExpense(actionId);
      if (status) {
        refresh()
        toast.success('Deleted Expense.', {
          description: 'Expense deleted Successfully.',

        });
      }
    } catch (error) {
      console.error('Error', error)
      if (error.message == "Can't delete: Matter records are related to this Expense.") {
        toast.warning('Failed to delete Expense.', {
          description: `Can't delete: Matter records are related to this Expense.`,

        });
        return
      }
      toast.error('Failed to delete Expense.', {
        description: 'An error occurred while deleting expense. Please try again later.',

      });
    }
  }

  const handleEdit = (id) => {
    Navigate(`/billing/expense/edit/${id}/`)
  }

  const handleClone = (id) => {
    Navigate(`/billing/expense/create/${id}/`)
  }

  const handleModalClose = () => {
    setItemId(null)
    setSelectedData(null)
    setMode('create')
    setOpen(false)
  }

  const renderCustomActions = (row) => {
    const { id } = row;

    return (
      <DropdownMenu>
        {(canDeleteExpense || canEditExpense) && (
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="text-gray-600">
              <KeenIcon icon="dots-vertical" className="text-[18px]" />
            </Button>
          </DropdownMenuTrigger>
        )}
        <DropdownMenuContent align="end" className="w-40">
          <Can I="handle" a="expense" ability={ability}>
            <DropdownMenuItem onClick={() => handleEdit(id)}>
              <KeenIcon icon="notepad-edit" className="mr-0.5 h-4 w-4 cursor-pointer" /> Edit
            </DropdownMenuItem>
          </Can>
          <Can I="handle" a="expense" ability={ability}>
            <DropdownMenuItem onClick={() => handleClone(id)}>
              <KeenIcon icon="note-2" className="mr-0.5 h-4 w-4 cursor-pointer" /> Clone
            </DropdownMenuItem>
          </Can>
          <Can I="delete" a="expense" ability={ability}>
            <DropdownMenuItem onClick={() => openModal(id)} className="text-red-600 cusror-pointer">
              <KeenIcon icon="trash" className="mr-0.5 h-4 w-4" /> Delete
            </DropdownMenuItem>
          </Can>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  };

  const ajaxConfig = createDataTableConfig('/setup/expense/data_table_list', filterRef, token, logout);

  const options = createDataTableOptions({
    order: [[9, 'desc']],
    drawCallback: function () {
      const api = this.api();
      const rows = api.rows({ page: 'current' }).data();

      rows.each((row) => {
        const container = document.getElementById(`action-cell-${row.id}`);
        if (container) {
          if (!container._reactRoot) {
            container._reactRoot = createRoot(container);
          }
          container._reactRoot.render(renderCustomActions(row));
        }
        const contactContainer = document.getElementById(`contact-cell-${row.id}`);
        if (contactContainer) {
          if (!contactContainer._reactRoot) {
            contactContainer._reactRoot = createRoot(contactContainer);
          }
          contactContainer._reactRoot.render(renderContactName(row));
        }
        const matterContainer = document.getElementById(`matter-cell-${row.id}`);
        if (matterContainer) {
          if (!matterContainer._reactRoot) {
            matterContainer._reactRoot = createRoot(matterContainer);
          }
          matterContainer._reactRoot.render(renderMatterName(row));
        }
        const billedContainer = document.getElementById(`billed-by-${row.id}`);
        if (billedContainer) {
          if (!billedContainer._reactRoot) {
            billedContainer._reactRoot = createRoot(billedContainer);
          }
          billedContainer._reactRoot.render(renderMultiAvatars(row.billed_by));
        }
      });
    },
  });

  const resetFilters = () => {
    const cleared = {
      assigned_to: null,
      status: null,
      created_at: null,
      tags: null,
    };

    setFilterData(cleared);
    filterRef.current = cleared;
    refresh()
  };

  const handleFilterChange = (key, val) => {
    setFilterData((prev) => {
      const updated = { ...prev, [key]: val };
      filterRef.current = updated;
      // //console.log('updated',updated)
      return updated;
    });
  };

  const handleToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const fetchLookup = async (type) => {
    switch (type) {
      case 'users':
        const { data } = await userService.getAllUsers();
        return data.map((user) => ({ label: user.first_name + ' ' + user.last_name, value: user.id, email: user.email }));
      case 'contact':
        return await fetchContactLookup();
      case 'matter':
        const matters = await matterService.getAllMatters();
        return matters.data.map((matter) => ({ label: matter.name, value: matter.id }));

      default:
        return [];
    }
  };

  const refresh = () => {
    const table = tableRef.current.dt();
    table.ajax.reload();
  };

  const renderContactName = (row) => {
    if (!row.contact) {
      return <span>-</span>;
    }
    const fullName = row.contact.first_name + ' ' + row.contact.last_name;
    const { id } = row.contact;
    return (
      <span onClick={() => { handleNavigateConatct(id) }} className='cursor-pointer link'>{fullName}</span>
    )
  }

  const handleNavigateConatct = (id) => {
    Navigate(`/contacts/${id}/`)
  }

  const handleNavigateMatter = (id) => {
    Navigate(`/matters/detail/${id}/`)
  }

  const renderMatterName = (row) => {
    const { matter } = row;
    const fullName = decodeHtmlEntities(matter?.name || '');

    return (
      <span
        onClick={() => handleNavigateMatter(matter?.id || '')}
        className="cursor-pointer link"
      >
        {fullName}
      </span>
    );
  }

  return (
    <>
      {/* Filters */}
      <FilterContainer
        show={showFilter}
        onApply={() => refresh()}
        onReset={resetFilters}
      >
        <SelectInput
          label="Billed By"
          type="users"
          value={filterData.billed_by}
          onChange={(val) => handleFilterChange('billed_by', val)}
          loadOptions={loadUserOptions}
          pageSize={20}
          customClass="sm:w-[32%] w-full"
        />

        {/* <SelectInput
                label="Contact"
                type="contact"
                value={filterData.contact}
                onChange={(val) => handleFilterChange('contact', val)}
                fetchLookup={fetchLookup}
                customClass="sm:w-[32%] w-full"
              />

              <SelectInput
                label="Matter"
                type="matter"
                value={filterData.matter}
                onChange={(val) => handleFilterChange('matter', val)}
                fetchLookup={fetchLookup}
                customClass="sm:w-[32%] w-full"
              /> */}

        <SelectInput
          label="Status"
          value={filterData.status}
          onChange={(val) => handleFilterChange('status', val)}
          staticOptions={STATUS_INVOICE_OPTIONS}
          customClass="sm:w-[32%] w-full"
        />

        <DateInput
          customClass="sm:w-[32%] w-full"
          label="Created At - (From, To)"
          mode="range"
          value={filterData.date_range}
          onChange={(range) => {
            setFilterData(prev => ({
              ...prev,
              from_date: range?.from ?? null,
              to_date: range?.to ?? null,
              date_range: range,
            }));
          }}
        />
      </FilterContainer>

      <div className="min-w-full mb-4 card">
        <div className="card-header">
          <h3 className="card-title">Expense</h3>

          <div className='flex flex-wrap items-center gap-2'>
            <button className='text-xs btn btn-sm btn-primary btn-outline' onClick={handleToggleFilter}>
              <KeenIcon icon="filter" className="w-fit btn-icon" />
              {showFilter ? 'Hide Advanced Filters' : 'Advanced Filters'}
            </button>
            {/* <Can I="handle" a="expense" ability={ability}>
            <Link to='/billing/expense/create' className='text-xs btn btn-sm btn-light'>
              <KeenIcon icon="plus" className="" />
              Add New
            </Link>
          </Can> */}
          </div>
        </div>


        <DataTable
          id="expense-contact-tab"
          ajax={ajaxConfig}
          columns={columns}
          options={options}
          ref={tableRef}
        />

        <ItemsModal
          open={open}
          onCloseModal={handleModalClose}
          handleMode={mode}
          data={selectedData}
          onSubmit={handleSubmit}
          createFieldLoading={isLoading}
          updateFieldLoading={loading}
          // taxesData={taxesData}
          ref={formikRef}
        />

        <ConfirmationModal
          show={isOpen}
          onClose={closeModal}
          onConfirm={handleDelete}
          message="Are you sure you want to delete this Expense? This action is permanent and cannot be undone."
          title="Are You Sure?"
        />
      </div>
    </>
  )
}

export { ExpensesContactTab }
